import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Paper, Typography } from '@mui/material';

import { imgLinks } from '../../../shared';
import {
  StyledClaimContactPersonInfo,
  StyledClaimContactPersonDetail,
  StyledPageDetailsHeadingContainer,
  StyledContentText,
} from './ClaimContactPerson.styled';

function ClaimContactPerson({ claim }) {
  return (
    <Paper>
      <StyledPageDetailsHeadingContainer>
        <img src={imgLinks[`icon.menu.orange.paw`]} alt="Paw" />

        <Typography variant="h3">
          <FormattedMessage id="claim.contact.person.title" />
        </Typography>
      </StyledPageDetailsHeadingContainer>

      <Typography variant="p" color="product_blue">
        <FormattedMessage
          id="claim.contact.person.text"
          values={{
            external_reference_number: claim?.externalContact?.externalClaimId || '--',
          }}
        />
      </Typography>

      <StyledClaimContactPersonDetail>
        <img src={imgLinks[`icon.menu.person`]} alt="Name" />
        <StyledContentText>
          <Typography variant="p">{claim?.externalContact?.name || '--'}</Typography>
        </StyledContentText>
      </StyledClaimContactPersonDetail>

      <StyledClaimContactPersonInfo>
        <StyledClaimContactPersonDetail>
          <img src={imgLinks[`icon.menu.phone`]} alt="Phone" />
          <StyledContentText>
            <Typography variant="p">{claim?.externalContact?.phoneNumber || '--'}</Typography>
          </StyledContentText>
        </StyledClaimContactPersonDetail>

        <StyledClaimContactPersonDetail>
          <img src={imgLinks[`icon.menu.email`]} alt="Email" />
          <StyledContentText>
            <Typography variant="p">{claim?.externalContact?.email || '--'}</Typography>
          </StyledContentText>
        </StyledClaimContactPersonDetail>
      </StyledClaimContactPersonInfo>
    </Paper>
  );
}

export default ClaimContactPerson;
